import { render, staticRenderFns } from "./usernotifications.vue?vue&type=template&id=755c9324&scoped=true&"
import script from "./usernotifications.vue?vue&type=script&lang=js&"
export * from "./usernotifications.vue?vue&type=script&lang=js&"
import style0 from "./usernotifications.vue?vue&type=style&index=0&id=755c9324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c9324",
  null
  
)

export default component.exports